import { createSlice } from "@reduxjs/toolkit";
import { LocalStorageKeys } from "../core";

const initialState = {
  isLoggedIn: localStorage.getItem(LocalStorageKeys.clientToken) ? true : false,
  client: null,
  token: localStorage.getItem(LocalStorageKeys.clientToken),
  isLoading: false,
  clients: [],
  clientBlockData: {},
  report: {},
  summary: {},
  performance: {},
  selectedYear: new Date().getFullYear(),
  yearOptions: [],
};

const clientReducerSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    changeClientLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },
    setClientState: (state, action) => {
      if (state.clients.length <= 0 || action.payload.refresh) {
        state.clients = action.payload.clients || state.clients;
      }
      state.isLoading = false;
    },
    setClientBlockData: (state, action) => {
      state.clientBlockData = action.payload;
      state.isLoading = false;
    },
    setClientReportById: (state, action) => {
      state.report = action.payload;
      state.isLoading = false;
    },
    addClientState: (state, action) => {
      state.clients.unshift(action.payload);
      state.isLoading = false;
    },
    deleteClientState: (state, action) => {
      state.clients = state.clients.filter(
        (client) => client._id !== action.payload,
      );
      state.isLoading = false;
    },
    clientSummary: (state, action) => {
      state.summary = action.payload;
      state.isLoading = false;
    },
    clientPerformaceSummary: (state, action) => {
      state.performance = action.payload;
      state.isLoading = false;
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload;
    },
    setYearOptions: (state, action) => {
      state.yearOptions = action.payload;
    },
  },
});

export const {
  changeClientLoadingState,
  setClientState,
  addClientState,
  deleteClientState,
  setClientBlockData,
  setClientReportById,
  clientSummary,
  clientPerformaceSummary,
  setSelectedYear,
  setYearOptions,
} = clientReducerSlice.actions;

export default clientReducerSlice.reducer;
